import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import Intercom, { shutdown, update } from '@intercom/messenger-js-sdk';

import './App.css';
import defaults from './constants/defaults';

import useTitle from './hooks/useTitle';

import { NavBar } from './components/elements';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ThemeLayout from './ThemeLayout';
 



const App = ({ children }) => {

  useTitle(defaults.tabbar.GENERAL);

  // const { boot, shutdown, hide, show, update } = useIntercom();

  const authenticated = useSelector(state => state.auth.authenticated)
  const accountActive = useSelector(state => state.auth.active)
  const user = useSelector(state => state.auth)

  const activeSwitch = useSelector(state => state.nav.sticky) || !!authenticated
  const shadowSwitch = useSelector(state => state.nav.shadow) || !!authenticated
  const menuToDisplay = useSelector(state => state.nav.menu)
  const pageRef = useSelector(state => state.nav.pageRef)
  const pageFocusMenu = useSelector(state => state.nav.pageFocusMenu)
  const goBackLink = useSelector(state => state.nav.goBackLink)
  const expandMenu = useSelector(state => state.nav.expandMenu)
  

  // Scroll to sections
  const ourAboutRef = useRef(null);
  const ourTeamRef = useRef(null);
  const ourFocusRef = useRef(null);
  const candidatesRef = useRef(null);
  const employersRef = useRef(null);
  const contactusRef = useRef(null);
  const wholePage = useRef(null);

  const injectedProps = { 
    ourAboutRef, 
    ourTeamRef,
    ourFocusRef,
    candidatesRef,
    employersRef,
    contactusRef,

    wholePage,
    
    onGoAbout: () => scrollTo(ourAboutRef),
    onGoTeam: () => scrollTo(ourTeamRef),
    onGoFocus: () => scrollTo(ourFocusRef),
    onGoCandidates: () => scrollTo(candidatesRef),
    onGoEmployers: () => scrollTo(employersRef),
    onGoContactUs: () => scrollTo(contactusRef),

  };

  const [activeSection, setActiveSection] = useState(null);

  // Observe sections to detect which is in view
  useEffect(() => {
    const sections = [
      { id: 'about', ref: ourAboutRef },
      { id: 'team', ref: ourTeamRef },
      { id: 'focus', ref: ourFocusRef },
      { id: 'candidates', ref: candidatesRef },
      { id: 'employers', ref: employersRef },
      { id: 'contactus', ref: contactusRef },
    ];


    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter(entry => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (visible) {
          const found = sections.find(s => s.ref.current === visible.target);
          if (found) setActiveSection(found.id);
        }
      },
      { threshold: 0.6 } // section is "active" when 60% visible
    );

    sections.forEach(({ ref }) => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => observer.disconnect();
  }, []);

  const scrollTo = (ref) => ref?.current?.scrollIntoView({ behavior: 'smooth' });


  // If we want to add Intercom... copied in here...
  // useEffect(() => {
  //   if (user.id) {
  //     update({
  //       user_id: user.id,
  //       email: user.email,
  //       name: user.name,
  //       created_at: user.created
  //     })
  //   } else {
  //     shutdown();

  //     Intercom({
  //       app_id: 'XXX'
  //     })
  //   }
  // }, [user])

  return (
     <ThemeLayout>
        {typeof children === 'function' ? children({ injectedProps }) : children}
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={true}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
            theme="light"
            toastStyle={{
              borderRadius: '12px',
              fontSize: '14px',
              padding: '12px 16px',
              top: 80
            }}
        />
    </ThemeLayout>
  )

}

export default App;
